import React from "react"

import Default from "../../Default"

const PageNotFound = () => {
  const title = "OOPS! Something went wrong here"
  const description = (
    <>
      <p>
        Sorry, we cannot find that page! <br />
        Either something went wrong or the page doesn`t exist anymore.
      </p>
    </>
  )

  return <Default title={title} description={description} />
}

export default PageNotFound
